// Contraste dinâmico das placas (spec §9.3): luminância média da região do PNG sob cada placa.
import { plateRegionsPx } from "./layout/artGeometryPt";

export const DEFAULT_PLATES = { name: "dark", grade: "dark", subgrades: "dark", meta: "dark" };
const THRESHOLD = 0.55;

export const luminance = (r, g, b) => (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

export function meanLuminance(getPixel, region, { samples = 8 } = {}) {
  let sum = 0;
  let count = 0;
  for (let i = 0; i < samples; i += 1) {
    for (let j = 0; j < samples; j += 1) {
      const x = Math.floor(region.x + ((i + 0.5) / samples) * region.width);
      const y = Math.floor(region.y + ((j + 0.5) / samples) * region.height);
      const [r, g, b] = getPixel(x, y) || [0, 0, 0];
      sum += luminance(r, g, b);
      count += 1;
    }
  }
  return count ? sum / count : 0;
}

export function decidePlates(getPixel, regions, { threshold = THRESHOLD } = {}) {
  const out = {};
  for (const [key, region] of Object.entries(regions)) {
    out[key] = meanLuminance(getPixel, region) > threshold ? "dark" : "light";
  }
  return out;
}

/** Browser: baixa o PNG (CORS anônimo), amostra e decide. Falha → DEFAULT_PLATES. */
export function platesFromImageUrl(url, geometry) {
  return new Promise((resolve) => {
    if (typeof Image === "undefined" || typeof document === "undefined") return resolve({ ...DEFAULT_PLATES });
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        const getPixel = (x, y) => {
          const cx = Math.min(Math.max(x, 0), canvas.width - 1);
          const cy = Math.min(Math.max(y, 0), canvas.height - 1);
          const i = (cy * canvas.width + cx) * 4;
          return [data[i], data[i + 1], data[i + 2]];
        };
        resolve(decidePlates(getPixel, plateRegionsPx(geometry, canvas.width)));
      } catch (_err) {
        resolve({ ...DEFAULT_PLATES });
      }
    };
    img.onerror = () => resolve({ ...DEFAULT_PLATES });
    img.src = url;
  });
}
